import styled from "styled-components";

export const Screen = styled.div``;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100dvh - 250px);
  gap: ${({ theme }) => theme.spacing[6]};
`;

export const Title = styled.div`
  font-size: ${({ theme }) => theme.fonts["3xl"].fontSize};
  max-width: 500px;
  text-align: center;
`;

export const SubTitle = styled.div`
  font-size: ${({ theme }) => theme.fonts.medium.fontSize};
  max-width: 500px;
  text-align: center;
`;
